import { render } from "./JobOfferCustomerService.vue?vue&type=template&id=03fb7532&scoped=true"
import script from "./JobOfferCustomerService.vue?vue&type=script&lang=js"
export * from "./JobOfferCustomerService.vue?vue&type=script&lang=js"

import "./JobOfferCustomerService.vue?vue&type=style&index=0&id=03fb7532&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03fb7532"]])

export default __exports__